export default __webpack_public_path__ + "static/weatherviewer-82c002fbb44b126f19fa4ef697281a71.png";